var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99977 10.2265V8.93315C9.99977 5.93315 12.4131 2.98649 15.4131 2.70649C16.2467 2.62459 17.0881 2.71812 17.8834 2.98107C18.6786 3.24401 19.41 3.67055 20.0304 4.23321C20.6509 4.79588 21.1466 5.48221 21.4858 6.24805C21.825 7.01388 22.0001 7.84224 21.9998 8.67982V10.5198M5.07977 22.0798L5.38644 24.5732C5.67977 27.1865 6.63977 29.3332 11.9998 29.3332H19.9998C25.3598 29.3332 26.3198 27.1865 26.5998 24.5732L27.5998 16.5732C27.9598 13.3198 27.0264 10.6665 21.3331 10.6665H10.6664C4.9731 10.6665 4.03977 13.3198 4.39977 16.5732",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6595 16H20.6715M11.3262 16H11.3368",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.2e78e4a633c9e7339b636bf09bf78bdb.svg";
export { ForwardRef as ReactComponent };